import { createContext } from 'react'
import RepoFactory from 'repoFactory'
import { ElementMapping, SORList } from 'ts/types'

interface AppState {
  repoFactory: RepoFactory | null
  isQEnabled: boolean
  sorElements: SORList | null
  sorElementMapping: ElementMapping | null
  error: boolean
  lastRunTime: string | null
  currentYear: number
  availableYears: number[]
  selectedYear: number
  setSelectedYear: (year: number) => void
  version: string
  packagingType: string
  accountMappingLimit: number
  isAppReady: boolean
  setIsLoading: (isLoading: boolean) => void
  isLoading: boolean
}

export const AppContext = createContext<AppState | null>(null)
